export const PHONE_NUMBER_PATTERN =
  /\+?\d{1,4}[\s.-]?\(?\d{1,3}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}/;

export const EMAIL_PATTERN =
  /^(([^@<>\s"(),.:;\\\\[\]]+(\.[^@<>\s"(),.:;\\\\[\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}\])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;
